const Spinner = () => {
  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-10'>
      <div className='animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-primary'></div>
    </div>
  );
};

export default Spinner;
